// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"15a60f98","760":"62db905c","821":"2110c099","888":"c202781b","964":"2193d6d5"}[chunkId] + ".chunk.js";
};